import DataAdminService from './DataAdminService';
import type IDataAdminService from './IDataAdminService';
import MockDataAdminService from './MockDataAdminService';

export default class DataAdminServiceFactory {
  dataAdminService: DataAdminService;

  constructor() {
    this.dataAdminService = new DataAdminService();
  }

  create(mode: string): IDataAdminService {
    if (mode.startsWith('test')) {
      return new MockDataAdminService(mode);
    } else {
      return this.dataAdminService;
    }
  }
}
